























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import { REGISTER_SYSTEM_ADMINISTRATOR } from '@/modules/employee/store';
import { RegisterSystemAdministrator } from '@/modules/employee/types';
import { createSystemAdministrator } from '@/modules/employee/admin/models';
import SalutationSelect from '@/modules/conservatorship/components/SalutationSelect.vue';

const Employee = namespace('employee');

@Component({
  components: {
    SalutationSelect
  }
})
export default class AdministratorForm extends Vue {
  @Employee.Action(REGISTER_SYSTEM_ADMINISTRATOR) register!: (params: RegisterSystemAdministrator) => Promise<ApiResponse>;

  error: any = null;
  loading: boolean = false;

  value: RegisterSystemAdministrator = createSystemAdministrator();

  reset(observer?: any) {
    this.error = null;
    this.value = createSystemAdministrator();
    observer && observer.reset();
  }

  cancel(observer?: any) {
    this.reset(observer);
    this.$emit('cancel');
  }

  back(observer: any) {
    this.reset(observer);
    this.$emit('back');
  }

  save() {
    this.error = null;

    return this.register(this.value);
  }
}
